<template>
  <div>
    <v-container dense>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card class="maincard" :loading="loading">
          <v-container>
            <v-row align="center">
              <v-col cols="12" xs="12" sm="6">
                <v-card-title>Mitarbeiterverwaltung</v-card-title>
              </v-col>
              <v-col cols="12" xs="12" sm="6" style="text-align: right">
                <v-btn
                  small
                  to="/mitarbeiter/edit"
                  color="success"
                  class="ml-3"
                >
                  <v-icon style="margin-right: 10px">mdi-account-plus</v-icon>
                  <span>Neuer Mitarbeiter</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" style="text-align: right">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="Customer && Customer.canIDCards"
                  small
                  @click="createIdCards()"
                  color="secondary"
                  class="mr-2"
                >
                  <v-icon style="margin-right: 10px">mdi-download</v-icon>
                  <span>ID Karten</span>
                </v-btn>
                <v-btn
                  small
                  color="secondary"
                  @click="showImportDialog"
                  class="ml-3"
                  >Importieren</v-btn
                >
              </v-col>
            </v-row>
          </v-container>

          <EmployeeUserList ref="UserList" />
        </v-card>
      </v-col>
      <v-dialog v-model="dlgImport" persistent max-width="90%">
        <v-card>
          <v-toolbar dark>
            <v-toolbar-title>Kunden importieren</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <userImport
              @close="dlgImport = false"
              @cancel="dlgImport = false"
              @importCompleted="importComplete"
              :axiosInstance="getAxiosInstance()"
              importUrl="/user/customerimport"
              :importFields="importFields"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import EmployeeUserList from "@/components/users/EmployeeUserList.vue";
import userImport from "@/components/csv-import/userImport";
import DataService from "@/services/DataService";
import UserService from "@/services/UserService.js";
import moment from "moment";
import FileSaver from "file-saver";

export default {
  name: "EmployeeUserMgmt",
  data: () => ({
    dlgImport: false,
    loading: false,
    importFields: [
      { text: "Anrede", value: "salutation", width: "150px" },
      { text: "Vorname", value: "firstname", width: "300px" },
      { text: "Nachname", value: "lastname" },
      { text: "Personalnr.", value: "persnr" },
      { text: "Email", value: "email", width: "200px" },
      { text: "Password", value: "password", width: "200px" },
      { text: "Sprache", value: "language", width: "200px" },
      { text: "Land", value: "country", width: "200px" },
      { text: "Abteilung", value: "department", width: "200px" },
      { text: "Telefon", value: "telefon" },
      { text: "NFC-Code", value: "nfcCard" },
    ],
  }),
  components: { EmployeeUserList, userImport },
  computed: {
    Customer() {
      return this.$store.getters["customer/getCurrent"];
    },
  },
  methods: {
    createIdCards() {
      //this.$refs.UserList.createIdCards();
      this.$store.commit("SET_APP_LOADING", true);
      UserService.createIdCards()
        .then((response) => {
          let filename = "idcards_" + moment().format("YYYY-MM-DD") + ".pdf";
          const bytes = new Uint8Array(response.data);

          FileSaver.saveAs(
            new Blob([bytes], {
              type: "application/pdf;",
            }),
            filename
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },
    getAxiosInstance() {
      return DataService.apiClient;
    },
    showImportDialog() {
      this.dlgImport = true;
    },
    importComplete() {
      console.log("import complete");
      this.loadUsers();
    },
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    },
    loadUsers() {
      this.loading = true;
      this.$store
        .dispatch("user/fetchUserList")
        .then((result) => {
          this.$store.commit("user/SET_USER_LIST", result.data.data);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    },
  },
};
</script>

<style scoped></style>
